const data = [
  {
    projectName: 'Flamingos',
    behanceLink: 'https://www.behance.net/embed/project/210846599?ilo0=1',
    width: '500px',
    height: '500px',
  },
  {
    projectName: 'Cranes',
    behanceLink: 'https://www.behance.net/embed/project/210846907?ilo0=1',
    width: '500px',
    height: '500px',
  },
  {
    projectName: 'Cactus',
    behanceLink: 'https://www.behance.net/embed/project/210847181?ilo0=1',
    width: '500px',
    height: '700px',
  },
  {
    projectName: 'Mini Paintings',
    behanceLink: 'https://www.behance.net/embed/project/210847483?ilo0=1',
    width: '500px',
    height: '700px',
  },
  {
    projectName: 'Macabre',
    behanceLink: 'https://www.behance.net/embed/project/210847763?ilo0=1',
    width: '500px',
    height: '700px',
  },
  {
    projectName: 'Urban Landscape',
    behanceLink: 'https://www.behance.net/embed/project/210848043?ilo0=1',
    width: '500px',
    height: '700px',
  },
];

export default data;
